module.exports = require('./CheckboxTemplate.jsx');


/** WEBPACK FOOTER **
 ** ./src/templates/CheckboxesTemplate.jsx
 **/